
import 'survey-core/defaultV2.min.css';
import { StylesManager, Model } from 'survey-core';
import styled from 'styled-components';
import { Survey } from 'survey-react-ui';
import theme from 'config/theme';

StylesManager.applyTheme("modern");
StylesManager.applyTheme("defaultV2");

const Container = styled.div`
  --primary: ${theme.colors.primary};
  --disable-color: ${theme.colors.primary};
  
  & .sd-table__cell {
    text-align: left;
  }

  ${({isComplete}) => isComplete ? `
    & .sd-action-bar {
      display: none;
    }
    & .sd-table__cell,
    & .sd-element__title.sd-element__title--disabled {
      opacity: 1;
    }
  ` : ''}

  @media print {
    .sd-radio__decorator {
      box-shadow: 0 0 0 1000px #ccc inset !important;
    }
  }
`

const AdoptionSurvey = ({survey, data, onComplete, isComplete}) => {

  const model = new Model(survey);
  if(data) {
    model.data = data;
  }

  model.onComplete.add(onComplete);

  if(isComplete) {
    model.showPreview();
  }

  return (
    <Container {...{isComplete}} >
      <Survey model={model} />
    </Container>
  );
}

export default AdoptionSurvey;
